<fieldset class="panel panel-white padding-0">
    <div class="panel-heading border-light">
        <h4 class="panel-title">Retention Invoices</h4>
        <ul class="panel-heading-tabs border-light">
            <li>
                <div class="btn-group">
                    <button
                        type="button"
                        class="btn btn-bx-primary"
                        (click)="addRetentionInvoice()"
                        [disabled]="!job.RetentionPaymentBalance">
                        <i class="ti-plus" tooltip="Add retention invoice" container="body"></i>
                    </button>
                </div>
            </li>
        </ul>
    </div>
    <div class="panel-body">
        <div class="row">
            <div class="col-xs-12">
                <div class="alert alert-info">
                    <p>
                        <strong>{{ job.RetentionPaymentPercentage }}%</strong> of each invoice will be retained, until
                        <strong>{{ job.RetentionPercentage }}%</strong> of the contract total ({{
                            job.RetentionType === 0 ? 'excl' : 'incl'
                        }}
                        {{ 'general.variations' | translate | lowercase }}) is reached.
                        <a (click)="changeRetentionType()" *ngIf="job.RetentionType === 0"
                            >Change to include {{ 'general.variations' | translate | lowercase }}</a
                        >
                    </p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-3 text-center">
                <div class="form-group text-large margin-bottom-5 margin-top-5">Retention Total (Ex)</div>
                <h4 tooltip="{{ translations.retentionTotalTooltip }}">
                    {{ job.RetentionTarget | bxCurrency }}
                    <small>
                        <span class="label label-info"> {{ job.RetentionPercentage }}% </span>
                        <span class="badge badge--for-tooltip">?</span>
                    </small>
                </h4>
            </div>
            <div class="col-xs-3 text-center">
                <div class="form-group text-large margin-bottom-5 margin-top-5">Retained to date (Ex)</div>
                <h4>
                    {{ job.RetentionTotal | bxCurrency }}
                    <small>
                        <span
                            class="label"
                            [ngClass]="{
                                'label-info': job.RetentionTotal !== job.RetentionTarget,
                                'label-success': job.RetentionTotal === job.RetentionTarget,
                            }">
                            {{ job.RetentionTotalPercentage }}%
                        </span>
                    </small>
                </h4>
            </div>
            <div class="col-xs-3 text-center">
                <div class="form-group text-large margin-bottom-5 margin-top-5">Invoiced (Ex)</div>
                <h4>{{ job.RetentionPaymentTotal | bxCurrency }}</h4>
            </div>
            <div class="col-xs-3 text-center">
                <div class="form-group text-large margin-bottom-5 margin-top-5">Remaining (Ex)</div>
                <h4>{{ job.RetentionPaymentBalance | bxCurrency }}</h4>
            </div>
        </div>

        <div class="table-wrapper" #tableWrapper *ngIf="rows.length">
            <ngx-datatable
                [ngStyle]="{ height: tableHeight }"
                #depositsTable
                class="material bxt-table"
                [rows]="rows"
                [rowHeight]="40"
                columnMode="force"
                [headerHeight]="50"
                [footerHeight]="0"
                [virtualization]="false"
                [sorts]="[{ prop: 'InvoiceDate', dir: 'desc' }]"
                [limit]="100">
                <!-- columns -->
                <ngx-datatable-column name="Invoice #" prop="InvoiceNumberString" [flexGrow]="1" [minWidth]="95" [sortable]="false">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <a class="bxt-row-action" (click)="viewInvoice(row)">
                            {{ row.InvoiceNumberString }}
                            <i
                                *ngIf="row.AccSyncData && row.AccSyncData !== 'blocked'"
                                class="ti-cloud-up"
                                tooltip="Synced to your accounting software"
                                container="body"></i>
                        </a>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Description" prop="Description" [flexGrow]="8">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <a class="bxt-row-action" (click)="viewInvoice(row)">
                            {{ row.Description }}
                        </a>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Invoiced" prop="InvoiceDate" [flexGrow]="2">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        {{ row.InvoiceDate | date }}
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Due" prop="DueDate" [flexGrow]="2">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        {{ row.DueDate | date }}
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Total (Ex)" prop="Total" [flexGrow]="2">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        {{ row.Total | bxCurrency }}
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Balance (Inc)" prop="BalanceTotalIncTax" [flexGrow]="2">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        {{ row.BalanceTotalIncTax | bxCurrency }}
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Status" prop="Status" [flexGrow]="2" [sortable]="false">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <span
                            class="label"
                            [ngClass]="{
                                'label-inverse': row.Status === 'Pending',
                                'label-warning': row.Status === 'Invoiced',
                                'label-info': row.Status === 'PartReceived',
                                'label-success': row.Status === 'Received',
                            }"
                            >{{ row.Status }}</span
                        >
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column
                    [width]="160"
                    [sortable]="false"
                    [canAutoResize]="false"
                    [draggable]="false"
                    [resizeable]="false"
                    [cellClass]="'right-align'"
                    [headerClass]="'disabled'">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <button
                            type="button"
                            class="btn btn-xs btn-info margin-left-5"
                            (click)="addReceipt(row)"
                            tooltip="Add Payment Receipt"
                            container="body"
                            [adaptivePosition]="false"
                            *ngIf="row.Status === 'Invoiced' || row.Status === 'PartReceived'">
                            <i class="ti-receipt"></i>
                        </button>
                        <button
                            type="button"
                            class="btn btn-xs btn-default margin-left-5"
                            (click)="shareInvoice(row)"
                            tooltip="Share"
                            container="body"
                            [adaptivePosition]="false">
                            Share
                        </button>
                        <button
                            type="button"
                            class="btn btn-xs btn-default margin-left-5"
                            (click)="printInvoice(row)"
                            tooltip="Print"
                            container="body"
                            [adaptivePosition]="false">
                            <i class="ti-printer"></i>
                        </button>
                        <button
                            type="button"
                            class="btn btn-xs btn-danger margin-left-5"
                            (click)="deleteInvoice($event, row)"
                            [disabled]="row.Status !== 'Pending'"
                            tooltip="Delete"
                            container="body"
                            [adaptivePosition]="false">
                            <i class="ti-trash"></i>
                        </button>
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>
        </div>
    </div>
</fieldset>
